import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'empathy-hidden-copy-choices-confirmation',
  templateUrl: 'copy-hidden-choices-confirmation.component.html'
})
export class CopyHiddenChoicesConfirmationComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<CopyHiddenChoicesConfirmationComponent>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
    this.dialogRef.disableClose = true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
